import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const CustomerGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewCustomer === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

CustomerGuard.propTypes = {
  children: PropTypes.node,
};

export default CustomerGuard;
